import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { Timecode } from '../shared';
/**
 * Represents a chunk of audio, which is part of a larger audio file
 */
export class AudioChunk {
    /**
     * @param location in which the object is stored
     * @param contentType A MIME type describing the content of the object
     * @param timecode The period during which this audio chunk was recorded
     * @param byteSize Size (in bytes) of the file
     */
    constructor(location, contentType, timecode, byteSize) {
        this.location = location;
        this.contentType = contentType;
        this.byteSize = byteSize;
        this.timecode = timecode;
    }
}
__decorate([
    Type(() => Timecode),
    __metadata("design:type", Timecode
    /**
     * @param location in which the object is stored
     * @param contentType A MIME type describing the content of the object
     * @param timecode The period during which this audio chunk was recorded
     * @param byteSize Size (in bytes) of the file
     */
    )
], AudioChunk.prototype, "timecode", void 0);
